<img src="/assets/steps-line.svg" alt="step line" *ngIf="!isLastStep()" />
